import http from "../../http-common";

export default class Callouts {
  getSimpleCallouts() {
    let url = `/call-outs?folderPath=%2FHome%2FSimpleCallouts`;

    return http.get(url);
  }
}